import React from 'react';
import { WrapperStyled } from './styles';

export const PageWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <WrapperStyled>{children}</WrapperStyled>;
};
